<template>
  <loading-icon class="c-card" v-if="loading"></loading-icon>
  <section :class="'c-card c-card-chart c-card-chart-' + getChartType" v-else>

    <div class="c-card__header">
      <h2 class="c-card__title t-headline qa-chart-title-header" v-if="card.title">{{ card.title }}</h2>
    </div>

		<h2 class="c-card__body qa-chart-description-header">
			{{ card.description }}
		</h2>

    <div v-if="dataAvailable" class="chart-container" style="position: relative;">
      <canvas ref="canvas"></canvas>
    </div>

    <h2 v-else class="c-card__body qa-description-header">
      {{ $t('web.card_chart.data_not_available') }}
    </h2>

  </section><!--END CARD-->
</template>





<script>
import Chart from 'chart.js'
import { mapGetters } from 'vuex'
import { merge, isArray } from 'lodash'

export default {
  name: 'ChartCard',
  props: ['card'],
  data () {
    return {
      chart: null
    }
  },
  computed: {
    ...mapGetters({
      chartData: 'chartData',
      websiteConfig: 'websiteConfig'
    }),
    colors () {
      if (isArray(this.websiteConfig.colors)) {
        return this.websiteConfig.colors
      }
      return [
        '#74b9ff',
        '#ff7675',
        '#55efc4',
        '#a29bfe',
        '#81ecec',
        '#fab1a0',
        '#ffeaa7',
        '#fd79a8',
        '#b2bec3',
        '#0984e3',
        '#d63031',
        '#00b894',
        '#6c5ce7',
        '#00cec9',
        '#e17055',
        '#fdcb6e',
        '#e84393',
        '#636e72'
      ]
    },
    /**
     * Confirms that the chartData for that specific card exists, if not then the card should show a message
     *
     * @returns {boolean}
       */
    dataAvailable () {
      return typeof this.chartData[this.card.id] !== 'undefined' && this.chartData[this.card.id] !== null &&
        typeof this.chartData[this.card.id]['labels'] !== 'undefined' && this.chartData[this.card.id]['labels'].length !== 0
    },
    loading () {
      return !this.card.cardLoaded
    },
    /**
     * Returns the correct type of the card to be used by the chart library
     *
     * @returns {any}
       */
    getChartType () {
      if (typeof this.chartData[this.card.id] === 'undefined') {
        return null
      }
      switch (this.chartData[this.card.id].type) {
        case 'BarChart':
          return 'bar'
        case 'LineChart':
          return 'line'
        case 'PieChart':
          return 'pie'
        case 'DonutChart':
          return 'doughnut'
      }
    }
  },
  mounted () {
    this.renderChart()
  },
  updated () {
    this.renderChart()
  },
  methods: {
    /**
     * Defines all the properties for each type of chart and merge them with a basic data/options object
     */
    renderChart () {
      let elem = this.$refs.canvas
      let chartType = this.getChartType
      if (typeof elem !== 'undefined' && typeof this.chartData[this.card.id] !== 'undefined' && chartType !== null) {
        var ctx = elem.getContext('2d')
        let data = {}
        let options = {}
        switch (chartType) {
          case 'line':
            data = {
              datasets: [{
                fill: false,
                label: this.chartData[this.card.id]['label'][0],
                borderWidth: 2,
                backgroundColor: this.colors[0],
                borderColor: this.colors[0]
              }]
            }
            options = {
              elements: {
                line: {
                  tension: 0
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    autoSkip: false // show all the labels on the x-axis
                  }
                }]
              }
            }
            break
          case 'pie':
          case 'doughnut':
            data = {
              datasets: [{
                label: this.chartData[this.card.id]['label'][0],
                borderWidth: 1,
                backgroundColor: (() => {
                  let bgcolors = []
                  for (let i = 0; i < this.chartData[this.card.id]['data'].length; i++) {
                    bgcolors.push(this.colors[i % this.colors.length])
                  }
                  return bgcolors
                })()
              }]
            }
            break
          case 'bar':
            data = {
              datasets: [{
                label: this.chartData[this.card.id]['label'][0],
                borderWidth: 1,
                backgroundColor: this.colors[0]
              }]
            }
            options = {
              scales: {
                xAxes: [{
                  ticks: {
                    autoSkip: false // show all the labels on the x-axis
                  }
                }]
              }
            }
            break
        }
        this.createChart(ctx, merge(this.getBasicDataObject(), data), merge(this.getBasicOptionsObject(), options))
      }
    },
    /**
     * Receive all the data and options needed to create the chart
     * @param ctx
     * @param data
     * @param options
       */
    createChart (ctx, data, options) {
      this.chart = new Chart(ctx, {
        type: this.getChartType,
        data: data,
        options: options
      })
    },
    /**
     * Returns a basic data object to be used by all the charts
     *
     * @returns {{labels: any, datasets: {data: any}[]}}
     */
    getBasicDataObject () {
      return {
        labels: this.chartData[this.card.id]['labels'],
        datasets: [{
          data: this.chartData[this.card.id]['data']
        }]
      }
    },
    /**
     * Returns a basic options object to be used by all the charts
     *
     * @returns {Object}
     */
    getBasicOptionsObject () {
      return {
        responsive: true,
        legend: {
          display: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Chart.vue?3aab8200